/***********************************************************
 API Routes
 --------------------------
 In here, we define all our API routes to not access them in code
 by magic strings.
 ************************************************************/

export default {
    settings: {
        show: '/v1/settings/{setting}'
    },

    jobs: {
        index: '/v1/jobs',
        show: '/v1/clubs/11/job-postings/{job}',

        categories: {
            index: '/v1/clubs/11/job-postings/categories'
        }
    },
}
